import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { PersistenceService } from "../store/model/persistence.service";
import { DivisionValidity } from "../store/validity/state";
import { ConsultationProcess, Division, Decision } from "../data/model";
import { productsByKey } from "../data/product.constants";

@Component({
    selector: "zbd-decision",
    exportAs: "decision",
    templateUrl: "decision.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            .product-version {
                font-size: 14px;
            }
        `,
    ],
})
export class DecisionComponent {
    @Input() persistence: PersistenceService;
    @Input() division: Division;
    @Input() validity: DivisionValidity;

    productsByKey = productsByKey;

    updateViaLink = (
        entity: Division,
        property: string,
        value: boolean,
    ): void => {
        const propagate = value && entity.Decision.IsAccepted != null;
        this.persistence.updateDivision(entity, "ViaLink", value, !propagate);
        if (propagate) {
            this.persistence.updateDecision(
                entity.Decision,
                "IsAccepted",
                null,
                true,
            );
        }
    };

    updateIsAccepted = (
        entity: Decision,
        property: string,
        value: boolean,
    ): void => {
        const propagate = this.division.ViaLink;
        this.persistence.updateDecision(
            this.division.Decision,
            "IsAccepted",
            value,
            propagate,
        );
        if (propagate) {
            this.persistence.updateDivision(
                this.division,
                "ViaLink",
                false,
                true,
            );
        }
    };
}
